import * as Vue from 'vue';
import mitt from 'mitt';
import globalStore from './stores/basket';
import verb from 'plural-ru';

try {
    window._ = require('lodash');

    window.plural = verb;

    require('lazyload');
} catch (e) {

}

const emitter = mitt();

window.emitter = emitter;

window.globalStore = globalStore;

const components = [];

const requireComponent = require.context('./', true, /\.vue$/i);

requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName);

    const componentName = _.upperFirst(
        _.camelCase(
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, '')
        )
    );

    components.push({name: componentName, config: componentConfig.default || componentConfig});
})

const createApp = () => {
    let app = Vue.createApp({});

    app.config.globalProperties.emitter = emitter;
    app.use(globalStore);

    components.forEach(component => app.component(component.name, component.config));

    return app;
}
window.createVueApp = createApp;

window.createVueComponents = () => document.querySelectorAll('[data-vue-app]')
    .forEach((element) => {
        if (element['__vue_app__'] === undefined) {
            createApp().mount(element)
        }
    });

createVueComponents();

// $(function () {
//     return createVueComponents();
// });

let images = document.querySelectorAll("img");
lazyload(images);


window.TEMPLATE_PATH = '/local/templates/main';
window.IMG_PATH = `${TEMPLATE_PATH}/assets/img`;

require('./scripts');
